import urlJoin from 'url-join';

import { useApi } from 'src/hooks/useApi';
import config from 'src/config';


const { titilerBaseUrl, tiffsAssetsBaseUrl } = config;

const useTitilerApi = () => {
  const { get } = useApi();
  return {
    getPixelValue: async ({ filePath, lon, lat }) =>
      await get(
        urlJoin(titilerBaseUrl, `/cog/point/${lon},${lat}`),
        { url: urlJoin(tiffsAssetsBaseUrl, filePath) },
      ),
  };
};


export { useTitilerApi };